import { AppShell, Box, Flex, Text, UnstyledButton } from "@mantine/core";
import { Outlet, useNavigate } from "react-router-dom";
import { IconArrowBack } from "@tabler/icons-react";
import { MotionConfig } from "framer-motion";
import { DashboardHeader } from "@/features/dashboard/components/DashboardHeader";
import { DashboardSidebar } from "@/features/dashboard/components/DashboardSideBar";
import { DashboardSecondarySidebar } from "@/features/dashboard/components/DashboardSecondarySideBar";
import { useDashboardLayout } from "@/features/dashboard/hooks/useDashboardLayout";

const SIDEBAR_WIDTH = 64;
const SECONDARY_WIDTH = 224;
const ANIMATION = "0.4s ease";

export function DashLayout() {
  const navigate = useNavigate();

  const {
    selectedMenu,
    isMenuOpened,
    changeIsMenuOpened,
    selectedMenuOption,
    changeSelectedMenuOption,
    selectedSubmenuOption,
    changeSelectedSubmenuOption,
    menuOptions,
  } = useDashboardLayout();

  return (
    <MotionConfig reducedMotion="user">
    <AppShell
      navbar={{
        width: isMenuOpened ? SIDEBAR_WIDTH + SECONDARY_WIDTH : SIDEBAR_WIDTH,
        breakpoint: "sm",
      }}
      styles={{
        navbar: {
          transition: `width ${ANIMATION}`,
          overflow: "hidden",
        },
      }}
    >
      <AppShell.Navbar p={0}>
        <Flex h="100%" wrap="nowrap">
          <Box w={SIDEBAR_WIDTH} h="100%">
            <DashboardSidebar
              selectedMenuOption={selectedMenuOption}
              changeSelectedMenuOption={changeSelectedMenuOption}
              menuOptions={menuOptions}
              isMenuOpened={isMenuOpened}
              changeIsMenuOpened={changeIsMenuOpened}
            />
          </Box>

          <Box
            w={isMenuOpened ? SECONDARY_WIDTH : 0}
            h="100%"
            style={{ overflow: "hidden", transition: `width ${ANIMATION}` }}
          >
            <Box w={SECONDARY_WIDTH} h="100%" style={{ whiteSpace: "nowrap", overflowY: "auto" }}>
              <DashboardSecondarySidebar
                selectedSubmenuOption={selectedSubmenuOption}
                changeSelectedSubmenuOption={changeSelectedSubmenuOption}
                menuTitle={selectedMenu?.subOptionsTitle ?? ""}
                menuSubOptions={selectedMenu?.subOptions ?? []}
              />
            </Box>
          </Box>
        </Flex>
      </AppShell.Navbar>

      <AppShell.Main w="100%" h="100%">
        <DashboardHeader />

        <Box bg="#FAFAFA" style={{ minHeight: "calc(100vh - 88px)" }} p={24}>
          <Flex
            mb={20}
            align="center"
            component={UnstyledButton}
            onClick={() => navigate(-1)}
          >
            <IconArrowBack color="#C8A977" />
            <Text c="#C8A977" mt={1}>Voltar</Text>
          </Flex>

          <Outlet />
        </Box>
      </AppShell.Main>
    </AppShell>
    </MotionConfig>
  );
}
